import React, { useEffect } from "react";
import NumberInput, { type Props as NumberInputProps, type NumericValue } from "components/NumberInput";
import { useValidate } from "formvalidation/hooks";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props extends Omit<NumberInputProps, "onChanged" | "onBlur" | "error" | "onEnterPressed" | "onEscPressed"> {
  autoFocus?: boolean
  onChange: (newValue: number) => void
  onEnterPressed?: (newValue: number) => void
  onEscPressed?: () => void
  validatorKey: string
}

const RequiredNumberInput = (props: Props) => {
  const semanticInputRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.autoFocus) {
      semanticInputRef.ref.current.focus();
    }
  }, []);

  const { onChange, validatorKey, onEnterPressed, onEscPressed, ...rest } = props;

  const validate = async (input: number | string) => {
    if (input == null || input === "") {
      return false;
    }

    const number = Number(input);
    const isValid = !Number.isNaN(number) && number !== 0;

    return isValid;
  };

  const validation = useValidate({
    key: validatorKey,
    title: validatorKey,
    value: props.value,
    validate: validate,
    ref: semanticInputRef.ref,
  })

  const onChanged = async (newValue: NumericValue) => {
    props.onChange(newValue.value);
  };

  return <NumberInput
    {...rest}
    innerRef={semanticInputRef.refSetter}
    error={validation.error.hasError}
    onEnterPressed={(v) => onEnterPressed?.(v.value)}
    onEscPressed={onEscPressed}
    onChanged={onChanged}
  />;
};

export default RequiredNumberInput;
